import lottie from 'lottie-web'
export class LottiePlayer extends HTMLElement {
  #animation
  #observer
  #pendingPromise
  connectedCallback() {
    if (this.src) {
      this.#loadAnimation(this.src)
    }

    this.#setupIntersectionObserver()
  }

  disconnectedCallback() {
    if (this.#animation) {
      this.#animation.destroy()
      this.#animation = null
    }

    this.#disconnectIntersectionObserver()
  }

  #setupIntersectionObserver() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.#play()
          } else {
            this.#pause()
          }
        }
      },
      {
        threshold: 0,
      },
    )
    this.#observer.observe(this)
  }

  #disconnectIntersectionObserver() {
    this.#observer.disconnect()
  }

  async #loadAnimation(url: string) {
    if (this.#animation) {
      this.#animation.destroy()
      this.#animation = null
    }

    let resolve, reject
    // eslint-disable-next-line promise/param-names
    this.#pendingPromise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })

    // eslint-disable-next-line compat/compat
    const animationData = await fetch(url).then((res) => res.json())

    try {
      this.#animation = lottie.loadAnimation({
        container: this,
        renderer: 'svg',
        loop: this.loop,
        autoplay: false,
        animationData,
      })

      resolve(this.#animation)
    } catch (e) {
      reject(e)
    } finally {
      this.#pendingPromise = null
    }
  }

  async #play() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }
    if (this.#pendingPromise) {
      await this.#pendingPromise
    }
    if (this.#animation) {
      this.#animation.play()
    }
  }
  async #pause() {
    if (this.#pendingPromise) {
      await this.#pendingPromise
    }

    if (this.#animation) {
      this.#animation.pause()
    }
  }

  get src(): string {
    return this.getAttribute('src')
  }

  get loop(): boolean {
    return this.hasAttribute('loop') && this.getAttribute('loop') === 'true'
  }
}
